// extracted by mini-css-extract-plugin
export default {"base":"Layout_base__9THHa","contentLeft":"Layout_contentLeft__pdTPd","contentRight":"Layout_contentRight__-YF-7"};